import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAnimatedNumber, LazyAnimatedTextByFill, LazyAnimatedTextByLine, LazyAnimatedTextByWord, LazyBlockTransition, LazyButtonArrow, LazyButtonClose, LazyButtonIcon, LazyCard, LazyCtaButton, LazyDotsCard, LazyFontSizeCalc, LazyGridDebugger, LazyGuidelines, LazyHeadMeta, LazyHoverReveal, LazyModal, LazyModalStory, LazyNavBarItem, LazyPageLoader, LazyPageWrapper, LazyPaginator, LazyParallax, LazyParallaxImage, LazyRenderBloks, LazyRenderRichText, LazyRivePlayer, LazyScrollCta, LazyScrollyVideo, LazySiteIn, LazySpinner, LazySplitLines, LazySplitLinesV1, LazyStickyBasePanel, LazyTheFooter, LazyTheLogo, LazyTheMenu, LazyTheNav, LazyTheNavBar, LazyTheSmoothScroll, LazyTheTransition, LazyTweakPane2, LazyViewportCalc, LazyColorAdjustment, LazyDots, LazyDotsCardThree, LazyDotsMap2, LazyDotsMap2Location, LazyDotsMap2LocationRing, LazyFlowMap, LazyScreenCamera, LazyThree, LazyConfigDotsMap, LazyFsTriangle, LazyLayers, LazyMapDotsMap, LazyMapDotsMapLocation, LazyMapDotsMapLocationPicker, LazyMapDotsMapLocations, LazyShadersHelpers, LazyV1DotsV1, LazyV1Dots, LazyV1DotsCardThreeV1, LazyV1DotsCardThree, LazyV1DotsMapV1, LazyV1DotsMapLocationV1, LazyV1FsTriangle, LazyV1FsTriangleCamera, LazyV1MeshTest, LazyV2Dots, LazyV2DotsCardThree, LazyFieldText, LazyFieldTextArea, LazyArticleContent, LazyArticleListing, LazyArticleListingItem, LazyCarousel1V1, LazyCarousel1V2, LazyCarousel1, LazyCarousel2, LazyCarouselCardArticle, LazyCarouselCardTimeline, LazyCarouselPrevNextControls, LazyColumns, LazyContent1, LazyCta, LazyEntryArticles, LazyEntryDivision, LazyEntryDivisionsV1, LazyEntryDivisions, LazyEntryDivisionsItem, LazyEnvironmentCard, LazyEnvironments, LazyExpertise1, LazyExpertise1Panel, LazyFormContact, LazyGallery1, LazyGallery1Item, LazyGallery2, LazyGenericItem, LazyHeroGeneric, LazyHeroVideo, LazyHeroVideoItem, LazyImage1, LazyIntroText, LazyLegalContent, LazyList1, LazyLocationHoverDetails, LazyLocations, LazyMediaV1, LazyMediaV2, LazyMedia, LazyMediaItem, LazyNavGroup, LazyNotFound, LazyNumberItem, LazyProcess1, LazyQuote1, LazyText1, LazyTimeline1, LazyVideoHotspot, LazyVideoHotspots, LazyVideoLoop, LazyVideoScroll, LazyExampleBlok, LazyContentArticle, LazyContentFooter, LazyContentNav, LazyContentPage, LazyContentEnvironment, LazyContentJob, LazyContentNews, LazyContentProduct, LazyContentProjects, LazyBrandedLogo, LazyFrame, LazyNuxt, LazyNuxtSeo, LazyPergel, LazySimpleBlog, LazyUnJs, LazyWave, LazyWithEmoji } from '#components'
const lazyGlobalComponents = [
  ["AnimatedNumber", LazyAnimatedNumber],
["AnimatedTextByFill", LazyAnimatedTextByFill],
["AnimatedTextByLine", LazyAnimatedTextByLine],
["AnimatedTextByWord", LazyAnimatedTextByWord],
["BlockTransition", LazyBlockTransition],
["ButtonArrow", LazyButtonArrow],
["ButtonClose", LazyButtonClose],
["ButtonIcon", LazyButtonIcon],
["Card", LazyCard],
["CtaButton", LazyCtaButton],
["DotsCard", LazyDotsCard],
["FontSizeCalc", LazyFontSizeCalc],
["GridDebugger", LazyGridDebugger],
["Guidelines", LazyGuidelines],
["HeadMeta", LazyHeadMeta],
["HoverReveal", LazyHoverReveal],
["Modal", LazyModal],
["ModalStory", LazyModalStory],
["NavBarItem", LazyNavBarItem],
["PageLoader", LazyPageLoader],
["PageWrapper", LazyPageWrapper],
["Paginator", LazyPaginator],
["Parallax", LazyParallax],
["ParallaxImage", LazyParallaxImage],
["RenderBloks", LazyRenderBloks],
["RenderRichText", LazyRenderRichText],
["RivePlayer", LazyRivePlayer],
["ScrollCta", LazyScrollCta],
["ScrollyVideo", LazyScrollyVideo],
["SiteIn", LazySiteIn],
["Spinner", LazySpinner],
["SplitLines", LazySplitLines],
["SplitLinesV1", LazySplitLinesV1],
["StickyBasePanel", LazyStickyBasePanel],
["TheFooter", LazyTheFooter],
["TheLogo", LazyTheLogo],
["TheMenu", LazyTheMenu],
["TheNav", LazyTheNav],
["TheNavBar", LazyTheNavBar],
["TheSmoothScroll", LazyTheSmoothScroll],
["TheTransition", LazyTheTransition],
["TweakPane2", LazyTweakPane2],
["ViewportCalc", LazyViewportCalc],
["ColorAdjustment", LazyColorAdjustment],
["Dots", LazyDots],
["DotsCardThree", LazyDotsCardThree],
["DotsMap2", LazyDotsMap2],
["DotsMap2Location", LazyDotsMap2Location],
["DotsMap2LocationRing", LazyDotsMap2LocationRing],
["FlowMap", LazyFlowMap],
["ScreenCamera", LazyScreenCamera],
["Three", LazyThree],
["ConfigDotsMap", LazyConfigDotsMap],
["FsTriangle", LazyFsTriangle],
["Layers", LazyLayers],
["MapDotsMap", LazyMapDotsMap],
["MapDotsMapLocation", LazyMapDotsMapLocation],
["MapDotsMapLocationPicker", LazyMapDotsMapLocationPicker],
["MapDotsMapLocations", LazyMapDotsMapLocations],
["ShadersHelpers", LazyShadersHelpers],
["V1DotsV1", LazyV1DotsV1],
["V1Dots", LazyV1Dots],
["V1DotsCardThreeV1", LazyV1DotsCardThreeV1],
["V1DotsCardThree", LazyV1DotsCardThree],
["V1DotsMapV1", LazyV1DotsMapV1],
["V1DotsMapLocationV1", LazyV1DotsMapLocationV1],
["V1FsTriangle", LazyV1FsTriangle],
["V1FsTriangleCamera", LazyV1FsTriangleCamera],
["V1MeshTest", LazyV1MeshTest],
["V2Dots", LazyV2Dots],
["V2DotsCardThree", LazyV2DotsCardThree],
["FieldText", LazyFieldText],
["FieldTextArea", LazyFieldTextArea],
["ArticleContent", LazyArticleContent],
["ArticleListing", LazyArticleListing],
["ArticleListingItem", LazyArticleListingItem],
["Carousel1V1", LazyCarousel1V1],
["Carousel1V2", LazyCarousel1V2],
["Carousel1", LazyCarousel1],
["Carousel2", LazyCarousel2],
["CarouselCardArticle", LazyCarouselCardArticle],
["CarouselCardTimeline", LazyCarouselCardTimeline],
["CarouselPrevNextControls", LazyCarouselPrevNextControls],
["Columns", LazyColumns],
["Content1", LazyContent1],
["Cta", LazyCta],
["EntryArticles", LazyEntryArticles],
["EntryDivision", LazyEntryDivision],
["EntryDivisionsV1", LazyEntryDivisionsV1],
["EntryDivisions", LazyEntryDivisions],
["EntryDivisionsItem", LazyEntryDivisionsItem],
["EnvironmentCard", LazyEnvironmentCard],
["Environments", LazyEnvironments],
["Expertise1", LazyExpertise1],
["Expertise1Panel", LazyExpertise1Panel],
["FormContact", LazyFormContact],
["Gallery1", LazyGallery1],
["Gallery1Item", LazyGallery1Item],
["Gallery2", LazyGallery2],
["GenericItem", LazyGenericItem],
["HeroGeneric", LazyHeroGeneric],
["HeroVideo", LazyHeroVideo],
["HeroVideoItem", LazyHeroVideoItem],
["Image1", LazyImage1],
["IntroText", LazyIntroText],
["LegalContent", LazyLegalContent],
["List1", LazyList1],
["LocationHoverDetails", LazyLocationHoverDetails],
["Locations", LazyLocations],
["MediaV1", LazyMediaV1],
["MediaV2", LazyMediaV2],
["Media", LazyMedia],
["MediaItem", LazyMediaItem],
["NavGroup", LazyNavGroup],
["NotFound", LazyNotFound],
["NumberItem", LazyNumberItem],
["Process1", LazyProcess1],
["Quote1", LazyQuote1],
["Text1", LazyText1],
["Timeline1", LazyTimeline1],
["VideoHotspot", LazyVideoHotspot],
["VideoHotspots", LazyVideoHotspots],
["VideoLoop", LazyVideoLoop],
["VideoScroll", LazyVideoScroll],
["ExampleBlok", LazyExampleBlok],
["ContentArticle", LazyContentArticle],
["ContentFooter", LazyContentFooter],
["ContentNav", LazyContentNav],
["ContentPage", LazyContentPage],
["ContentEnvironment", LazyContentEnvironment],
["ContentJob", LazyContentJob],
["ContentNews", LazyContentNews],
["ContentProduct", LazyContentProduct],
["ContentProjects", LazyContentProjects],
["BrandedLogo", LazyBrandedLogo],
["Frame", LazyFrame],
["Nuxt", LazyNuxt],
["NuxtSeo", LazyNuxtSeo],
["Pergel", LazyPergel],
["SimpleBlog", LazySimpleBlog],
["UnJs", LazyUnJs],
["Wave", LazyWave],
["WithEmoji", LazyWithEmoji],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
